import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationSavedFilterEntity } from '../../domain/entities/investigation-saved-filter.entity';
import { InvestigationPredefinedFiltersApi } from '../api/investigation-predefined-filters.api';
import { InvestigationPredefinedFiltersMapper } from '../mappers/investigation-predefined-filters.mapper';

@Injectable({ providedIn: 'root' })
export class InvestigationPredefinedFiltersRepository {
  private readonly _api = inject(InvestigationPredefinedFiltersApi);
  private readonly _mapper = inject(InvestigationPredefinedFiltersMapper);

  public getPredefinedFilters(): Observable<InvestigationSavedFilterEntity[]> {
    return this._api.getPredefinedFilters().pipe(map((dtos) => this._mapper.toDomainArray(dtos)));
  }
}
